var moduleMap = {
	"./LessonsApp": () => {
		return Promise.all(/* __federation_expose_LessonsApp */[__webpack_require__.e(598), __webpack_require__.e(843), __webpack_require__.e(236)]).then(() => (() => ((__webpack_require__(7957)))));
	},
	"./LessonStore": () => {
		return Promise.all(/* __federation_expose_LessonStore */[__webpack_require__.e(618), __webpack_require__.e(598), __webpack_require__.e(445), __webpack_require__.e(843), __webpack_require__.e(973), __webpack_require__.e(287)]).then(() => (() => ((__webpack_require__(2327)))));
	},
	"./LessonStoreContext": () => {
		return Promise.all(/* __federation_expose_LessonStoreContext */[__webpack_require__.e(618), __webpack_require__.e(598), __webpack_require__.e(445), __webpack_require__.e(843), __webpack_require__.e(973), __webpack_require__.e(324)]).then(() => (() => ((__webpack_require__(6002)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});